import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
// import { Options } from '@angular-slider/ngx-slider';
import { SessionService } from '../../../session-service/session.service';
import { API_URL } from '../../../constants/apiurl-constants';
import { GetAllUsersResponse } from '../../../models/get-all-users-response.model';
import { GetClientsResponse } from '../../../models/get-clients-response.model';
import { Engagement } from 'src/app/shared/models/engagement/engagement.model';
import { role } from 'src/app/shared/constants/role-enum';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Injectable({ providedIn: 'root' })
export class CreateStudyService {
    engagementTempData: Engagement;
    private _destroyed$ = new Subject<void>();
    private clientUsersDataSource = new BehaviorSubject<GetClientsResponse>({} as GetClientsResponse);
    clientUsersDataSource$ = this.clientUsersDataSource.asObservable();

    private kpmgUsersDataSource = new BehaviorSubject<GetAllUsersResponse>({} as GetAllUsersResponse);
    kpmgUsersDataSource$ = this.kpmgUsersDataSource.asObservable();
    userRole: role = role.none;

    constructor(private sessionService: SessionService, private _userDataService: UserDataService) {
        let isClientAdmin = false;
        this._userDataService.userDetails$.pipe(
            takeUntil(this._destroyed$)
        ).subscribe(userData => {
            if (userData && userData.roleId) {
                isClientAdmin = userData.roleId === role.clientAdmin ? true : false;
            }
            this.userRole = userData.roleId;
            if (this.userRole !== role.clientManager && this.userRole !== role.respondent && !isClientAdmin) {
                this.getClientNames();
                this.getKpmgUsers();
            }
        });
    }

    getKpmgUsers() {
        this.sessionService.apiUrlGet(API_URL.CLIENT.GET_ALL_USER).subscribe(serviceResponse => {
            if (serviceResponse) {
                let kpmgUserResponse = serviceResponse as GetAllUsersResponse;
                this.kpmgUsersDataSource.next(kpmgUserResponse);
            }
        });
    }

    getEmailReminderFrequencyOptions(): any {
        let emailReminderFrequencyOptions: any = {
            floor: 0,
            ceil: 10,
            getPointerColor: (value: number): string => {
                if (value === 0) {
                    return 'red';
                } else {
                    return '#28a745';
                }
            },
        };
        return emailReminderFrequencyOptions;
    }

    checkEngagementNumber(engagementNumber: any) {
        return this.sessionService.apiUrlGet(
            API_URL.ENGAGEMENT.CHECKENGAGMENTNUMBER +
            '?engagementNumber=' +
            engagementNumber,
        );
    }

    CheckEngagementName(engagementName: any, clientIdSelected: number) {
        return this.sessionService.apiUrlGet(
            API_URL.ENGAGEMENT.CHECKENGAGEMENTNAME +
            '?engagementName=' +
            engagementName +
            '&clientId=' +
            clientIdSelected,
        );
    }

    getClientNames() {
        this.sessionService.apiUrlGet(API_URL.GETCLIENTNAMES).subscribe(serviceResponse => {
            if (serviceResponse) {
                let clientDataResponse = serviceResponse as GetClientsResponse;
                this.clientUsersDataSource.next(clientDataResponse);
            }
        });
    }

    GetClientUsers(clientId: number) {
        return this.sessionService.apiUrlGet(
            API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientId,
        );
    }

    CreateEngagement(engagement: any) {
        return this.sessionService.apiUrlPost(
            API_URL.ENGAGEMENT.CREATENGAGEMENT,
            engagement,
        );
    }
}
